/**
 * @license lucide v0.294.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const Activity = [
  "svg",
  defaultAttributes,
  [["path", { d: "M22 12h-4l-3 9L9 3l-3 9H2" }]]
];

export { Activity as default };
//# sourceMappingURL=activity.js.map
